import React from "react";
import { Container, Typography, Box, TextField } from "@mui/material";
import { useFormContext } from "../FormContext";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";

const Heading = () => {
  const { formData, updateFormData } = useFormContext();

  const handleChange = (e) => {
    const { name, value } = e.target;
    updateFormData({ [name]: value });
  };

  return (
    <Container maxWidth="xl" disableGutters>
      <Box sx={{ textAlign: "center", px: { xs: 2, sm: 4, md: 10 }, pt: 4 }}>
        <Typography
          variant="h2"
          component="h2"
          sx={{
            textTransform: "uppercase",
            color: "black",
            fontWeight: "bold",
            fontSize: { xs: "1rem", md: "1.5rem", xl: "2rem" },
            borderBottom: "2px solid",
            py: 3,
          }}
        >
          AGREEMENT FOR PROVIDING TRANSPORTATION FOR STUDENTS OF DELHI PRIVATE SCHOOL – JEBEL ALI
        </Typography>

        {/* <Typography
          variant="body1"
          component="p"
          sx={{
            mb: 2,
            mt: 4,
            textAlign: 'justify',
            fontSize: { xs: '0.75rem', md: '1rem', xl: '1.5rem' },
          }}
        >
          This agreement is made on the
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
              value={formData.date ? moment(formData.date) : null}
              onChange={(newValue) => {
                updateFormData({ date: newValue ? newValue.format('YYYY-MM-DD') : null });
              }}
              slotProps={{
                textField: {
                  variant: "standard",
                  size: "small",
                  sx: {
                    mx: 0.5,
                    my: 0.5,
                    width: 'calc(20% - 2px)',
                    '& input': {
                      fontSize: { xs: '0.6rem', md: '0.8rem', xl: '1.2rem' },
                      textAlign: 'center',
                      p: 0,
                    },
                  }
                }
              }}
            />
          </LocalizationProvider>
          between AL SARAYA BUSES RENTAL LLC (Hereafter referred to as
          ASB), P.O BOX 37978, Dubai, UAE and Mr/ Mrs.
          <TextField
            variant="standard"
            name="parent"
            size="small"
            onChange={handleChange}
            value={formData.parent || ""}
            sx={{
              mx: 1,
              my: 1,
              width: 'calc(20% - 2px)',
              '& input': {
                fontSize: { xs: '0.6rem', md: '0.8rem', xl: '1.2rem' },
                textAlign: 'center',
              },
            }}
          />
          Father / Mother (Hereafter referred to as PARENT) Of
          <TextField
            variant="standard"
            name="student"
            size="small"
            onChange={handleChange}
            value={formData.student || ""}
            sx={{
              mx: 1,
              my: 1,
              width: 'calc(20% - 2px)',
              '& input': {
                fontSize: { xs: '0.6rem', md: '0.8rem', xl: '1.2rem' },
                textAlign: 'center',
              },
            }}
          />
          (student) Reg-No
          <TextField
            variant="standard"
            name="regNo"
            size="small"
            onChange={handleChange}
            value={formData.regNo || ""}
            sx={{
              mx: 1,
              my: 1,
              width: 'calc(10% - 2px)',
              '& input': {
                fontSize: { xs: '0.6rem', md: '0.8rem', xl: '1.2rem' },
                textAlign: 'center',
              },
            }}
          />
          Grade
          <TextField
            variant="standard"
            name="grade"
            size="small"
            onChange={handleChange}
            value={formData.grade || ""}
            sx={{
              mx: 1,
              my: 1,
              width: 'calc(5% - 2px)',
              '& input': {
                fontSize: { xs: '0.6rem', md: '0.8rem', xl: '1.2rem' },
                textAlign: 'center',
              },
            }}
          />
          of DPS- JEBEL ALI (Hereinafter referred to as SCHOOL).
        </Typography> */}

        <Typography
          variant="h3"
          component="h3"
          sx={{
            textAlign: "left",
            color: "black",
            fontWeight: "bold",
            fontSize: { xs: "0.9rem", md: "1.2rem", xl: "1.5rem" },
            py: 3,
          }}
        >
          The terms and conditions of this agreement will be effective from the first day of
          transport use to last day of transport use in the respective school:
        </Typography>
      </Box>
    </Container>
  );
};

export default Heading;
